import Extent from "@arcgis/core/geometry/Extent";
export const calculateGraphicsExtent = (graphics) => {
    if (graphics.length === 0) {
        return null;
    }

    let extent = graphics[0].geometry.extent;
    graphics.forEach(function (graphic) {
        if (graphic.geometry.extent) {
            extent = extent ? extent.union(graphic.geometry.extent) : graphic.geometry.extent;
        } else {
            const pointExtent = new Extent({
                xmin: graphic.geometry.x,
                ymin: graphic.geometry.y,
                xmax: graphic.geometry.x,
                ymax: graphic.geometry.y,
                spatialReference: graphic.geometry.spatialReference
            });
            extent = extent ? extent.union(pointExtent) : pointExtent;
        }
    });
    return extent;
};

export const getSymbol = (geometryType) => {
    if (geometryType === "polygon") {
        return {
            type: "simple-fill",
            color: [255, 0, 0, 0.5],
            outline: {
                color: [255, 0, 0],
                width: 1
            }
        };
    } else if (geometryType === "point" || geometryType === "multipoint") {
        return {
            type: "simple-marker",
            color: "red",
            size: "8px"
        };
    } else if (geometryType === "polyline" || geometryType === "linestring") {
        return {
            type: "simple-line",
            color: [255, 0, 0],
            width: 2
        };
    }
    return null;
}